import { useTimelineClockValue } from 'features/mapping/state/useTimelineClockState';
import { LightningTimelineLegend } from './LightningTimelineLegend';
import { getLightningTimeFilter } from './LightningLayer.utils';
import { useLightningStrikeCounts } from './useLightningStrikeCounts';

type ConnectedLightningTimelineLegendProps = {
  /** Hides counts collected from tiles that are still loading */
  isLoading: boolean;
};

/** Rendered only while lightning is the active timeline layer. */
export const ConnectedLightningTimelineLegend = ({
  isLoading,
}: ConnectedLightningTimelineLegendProps): JSX.Element => {
  const clock = useTimelineClockValue();
  const timeFilter = getLightningTimeFilter('lightning', clock, Date.now());
  const { counts, isLoading: isCountsLoading } = useLightningStrikeCounts(
    timeFilter === 'hidden' ? null : timeFilter,
  );

  return (
    <LightningTimelineLegend
      counts={counts}
      isLoading={isLoading || isCountsLoading}
    />
  );
};
